<template>
  <div v-if="isValid">
    <v-main>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-flex xs12 text-xs-center>
            <v-img :src="require('../assets/hp-logo.gif')" class="my-3" contain height="200"></v-img>
          </v-flex>

          <v-flex xs12 text-xs-center>
            <h1 class="display-2 font-weight-bold mb-3" align="center">{{ companyName }} {{ year }}</h1>
          </v-flex>
          <br />

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >1. How would you rate your online booking experience?</h2>

            <v-radio-group v-model="answers.bookingExperience" :rules="[rules.required]" row>
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">2. Did your appointment start on time?</h2>

            <v-radio-group v-model="answers.onTime" :rules="[rules.required]" column>
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="No" value="no"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >3. Did you feel there was enough time to discuss your results?</h2>

            <v-radio-group v-model="answers.discussResults" :rules="[rules.required]" column>
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="No" value="no"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              4. Will you, or have you, made any lifestyle changes since your
              assessment?
            </h2>

            <v-radio-group v-model="answers.lifestyleChange" :rules="[rules.required]" column>
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="No" value="no"></v-radio>
              <v-radio label="I Don't Know" value="dontknow"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              5. How would you rate the quality and professionalism of your health
              assessor?
            </h2>

            <v-radio-group v-model="answers.professionalism" :rules="[rules.required]" row>
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >6. How would you rate your overall health assessment experience?</h2>

            <v-radio-group v-model="answers.experience" :rules="[rules.required]" row>
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >7. Would you recommend your experience to a colleague/friend?</h2>

            <v-radio-group v-model="answers.recommend" :rules="[rules.required]" column>
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="No" value="no"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              8. Would you like to participate in future health assessment
              programmes?
            </h2>

            <v-radio-group v-model="answers.participate" :rules="[rules.required]" column>
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="No" value="no"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >9. We love feedback! Please add any further comments about your health assessment experience.</h2>

            <v-textarea
              v-model="answers.comment"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-btn block color="#b0cf3d" class="float-right mb-10" @click="save">Submit</v-btn>
        </v-form>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
export default {
  async created() {
    var that = this;
    API.graphql(
      graphqlOperation(queries.getSurveyHealthAssessment, {
        id: this.$route.params.id,
      })
    )
      .then((result) => {
        this.isValid = true;
        let answer = result.data.getSurveyHealthAssessment;
        this.companyName = answer.companyName;
        this.answers = {};

        for (var property in answer) {
          if (answer.hasOwnProperty(property)) {
            if (answer[property]) {
              this.answers[property] = answer[property];
            }
          }
        }
      })
      .catch((err) => {
        that.isValid = false;
      });
  },
  data: () => ({
    answers: [],
    isValid: true,
    companyName: "",
    year: new Date().getFullYear(),
    rules: {
      required: (v) => !!v || "This field is required.",
    },
  }),
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const client = {
          id: this.answers.id,
          onTime: this.answers.onTime,
          discussResults: this.answers.discussResults,
          lifestyleChange: this.answers.lifestyleChange,
          professionalism: this.answers.professionalism,
          bookingExperience: this.answers.bookingExperience,
          experience: this.answers.experience,
          recommend: this.answers.recommend,
          participate: this.answers.participate,
          comment: this.answers.comment,
        };

        const updateClient = API.graphql(
          graphqlOperation(mutations.updateSurveyHealthAssessment, {
            input: client,
          })
        )
          .then((res) => {
            this.$router.push({ path: "/thankyou" });
          })
          .catch((err) => (this.error = err.message));
      }
    },
  },
};
</script>

<style>
.v-radio {
  margin-right: 50px;
}
</style>